import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { InjuryGroupsInterface } from '@interfaces/injuries.interface';
import { InjuryService } from '@/services/injury.service';
import { BaseComponent } from '../base.component';


@Component({
    selector: 'app-grouped-participant-injuries',
    templateUrl: './grouped-participant-injuries.component.html',
})
export class GroupedParticipantInjuriesComponent extends BaseComponent implements OnDestroy, OnInit {
    @Input()
    public sportId: number;

    @Input()
    public sportName: string;

    @Input() participantId!: number;

    @Input()
    public seasonId: number | null = null;

    @Input()
    public weekIds: number[] = [];

    @Input()
    public splitByGroup: boolean = true;

    public subscriber: Subscription;
    public injuryGroups: InjuryGroupsInterface | null = null;

    public constructor(
        private injuryService: InjuryService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.load(true);
    }

    public ngOnDestroy(): void {
        this.subscriber.unsubscribe();
    }

    private async load(loadLatestWeekInjuries: boolean = false): Promise<any> {
        try {
            const data = await this.injuryService.getInjuryGroups(
                this.seasonId,
                null,
                this.weekIds,
                loadLatestWeekInjuries,
                this.participantId,
            );

            this.subscriber = data.subscribe((data: InjuryGroupsInterface) => {
                this.weekIds = data.week_ids;
                this.injuryGroups = data;
            });
        } catch (e) {
            console.log(e);
        }
    }

    public toggleWeek(weekId: number) {
        window.requestAnimationFrame((): void => {
            const position = this.weekIds.indexOf(weekId);
            if (~position) {
                this.weekIds.splice(position, 1);
            } else {
                this.weekIds.push(weekId);

            }
            console.log('click', this.weekIds);
            this.load();
        });


    }

    public weekOpened(weekId: number): boolean {
        const position = this.weekIds.indexOf(weekId);
        return Boolean(~position);
    }
}
